import desktopViewTemplateUrl from './planning-resources-volunteer-programs.html';
import mobileViewTemplateUrl from './planning-resources-volunteer-programs-map-mobile-view.html';
import popupTemplateUrl from './planning-resources-volunteer-programs-details-popup.html';
import mobileViewDetailsTemplateUrl from './planning-resources-volunteer-programs-map-details-mobile-view.html';
import head from 'lodash/head';
import filter from 'lodash/filter';

export const planningResourcesVolunteerProgramsComponent = {
    template: '<div ng-include="$ctrl.templateUrl"></div>',

    bindings: {
        data: '<'
    },

    controller: class PlanningResourcesVolunteerProgramsComponent {
        constructor($window, $scope, $anchorScroll, $stateParams, toastr, ApiService, ModalService, VolunteerProgramsMapService) {
            'ngInject';

            this.$window = $window;
            this.$scope = $scope;
            this.$anchorScroll = $anchorScroll;
            this.$stateParams = $stateParams;
            this.toastr = toastr;
            this.apiService = ApiService;
            this.modalService = ModalService;
            this.volunteerProgramsMapService = VolunteerProgramsMapService;
            this.desktopViewTemplateUrl = desktopViewTemplateUrl;
            this.mobileViewTemplateUrl = mobileViewTemplateUrl;
            this.popupTemplateUrl = popupTemplateUrl;
            this.mobileViewDetailsTemplateUrl = mobileViewDetailsTemplateUrl;
        }

        $onInit() {
            this.templateUrl = this.desktopViewTemplateUrl;
            this.latlng = [];
            this.showOverlay = true;
            const screenWidth = this.$window.innerWidth;
            if (screenWidth > 768) {
                this.selectedProvider = head(this.data.volunteerPrograms);
                this.selectedProvider.isSelected = true;
                this.isProviderSelected(this.selectedProvider.id);
            }
        }

        _getImage(detail) {
            const image = detail ? detail.image : '';
            return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '/./images/placeholder.png';
        }

        _getClass(type) {
			return type === 'Public Transit' ? 'publicType' : type === 'Private Transportation' ? 'privateType' : type === 'Paratransit' ? 'paraTransit' : type === 'Volunteer' ? 'volunteer' : type === 'Other' ? 'otherType' : 'noType';
		}

        isProviderSelected(id, index) {
            this.showOverlay = true;
            let newHash = `anchor${index}`;
            this.$anchorScroll(newHash);
            this.$anchorScroll.yOffset = 50;
            this.data.volunteerPrograms.map(provider => provider.isSelected = provider.id === id ? true : false);
            this.volunteerProgramsMapService.getAreaLatLngData(id).then(details => {
                this.showOverlay = false;
                if (details) {
                    let data = filter(details.values, value => value != undefined);
                    if (data.length > 0) {
                        this.latlng = angular.copy(details);
                    } else {
                        this.latlng = [];
                        this.toastr.error('Data not available for the selected provider');
                    }
                }
            });
        }

        isProviderSelectedInMobileView(id) {
            this.$window.scrollTo(0, 0);
            this.templateUrl = this.mobileViewTemplateUrl;
            this.showOverlay = true;
            this.volunteerProgramsMapService.getVolunteerProgramsdetailById(id).then(details => {
                this.providerDetails = head(details.volunteerPrograms);
            });
            this.volunteerProgramsMapService.getAreaLatLngData(id).then(details => {
                this.showOverlay = false;
                if(details) {
                    let data = filter(details.values, value => value != undefined);
                    if (data.length > 0) {
                        this.latlng = angular.copy(details);
                    } else {
                        this.latlng = [];
                        this.toastr.error('Data not available for the selected provider');
                    }
                }
            });
        }

        mobileViewDetails(id) {
            this.$window.scrollTo(0, 0);
            this.templateUrl = this.mobileViewDetailsTemplateUrl;
        }

        onMapGoBack() {
            this.templateUrl = this.desktopViewTemplateUrl;
        }

        onMapDetailsGoBack() {
            this.templateUrl = this.mobileViewTemplateUrl;
        }

        onClose() {
            this.modal.close();
        }

        viewDetails(id) {
            this.volunteerProgramsMapService.getVolunteerProgramsdetailById(id).then((details) => {
                this.showOverlay = false;
                this.details = head(details.volunteerPrograms);
                this.modal = this.modalService.open({
                    templateUrl: this.popupTemplateUrl,
                    details: {
                        data: this.details,
                        onClick: this.onClose.bind(this),
                        _getClass: this._getClass.bind(this)
                    }
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/planning-resources-volunteer-programs/planning-resources-volunteer-programs.component.js